import { useEffect, useState } from 'react';

import { getProfileByPatient } from '../../../../api/profile/create_profile.js';
import { fetchProfileInfo } from '../../../../api/dispensary/script/processScriptApi.js';

export const useScriptPatientProfile = (scriptData) => {
    const [patientProfile, setPatientProfile] = useState(null);

    useEffect(() => {
        const pid = scriptData?.patientId;

        if (!pid) return;
        let alive = true;
        (async () => {
            try {
                const prof = await getProfileByPatient(pid);
                if (!alive || !prof) return;

                const main = prof.main || {};
                const mm = prof.mainmember || {};
                const requested = prof.patient || {};
                const profile = prof.profile || {};

                const profileNumber =
                    profile.profilenumber ||
                    mm.profilenumber ||
                    scriptData?.profileNo;

                const addrSource =
                    requested.homeaddress ||
                    main.homeaddress;
                const addr = addrSource
                    ? [String(addrSource)]
                    : (Array.isArray(scriptData?.addressLines) ? scriptData.addressLines : []);

                const phoneVal =
                    requested.contactnumber ||
                    main.contactnumber ||
                    scriptData?.phone ||
                    '';

                const medAidNumber =
                    mm.medicalaidnumber ||
                    mm.medicalaidno ||
                    mm.medicalAidNumber ||
                    mm.medicalAidNo ||
                    mm.medicalaidprovider ||
                    scriptData?.medicalAidNumber ||
                    '';

                setPatientProfile({
                    profileNo: profileNumber || scriptData?.profileNo || '',
                    addressLines: addr,
                    phone: phoneVal,
                    medicalAid: medAidNumber,
                });
            } catch (e) {
            }
        })();
        return () => { alive = false; };
    }, [scriptData?.patientId, scriptData?.profileNo, scriptData?.addressLines, scriptData?.phone, scriptData?.medicalAidNumber]);

    // Additional profile enrichment based on profileNo, mirroring
    // ScriptForm/new-script flow: build addressLines and phone from
    // mainPatient/mainMember/patient when available.
    useEffect(() => {
        const pno = scriptData?.profileNo;
        if (!pno) return;
        let alive = true;
        (async () => {
            try {
                const info = await fetchProfileInfo(pno);
                if (!alive || !info) return;

                const main = info.mainPatient || info.mainMember || info.patient || null;
                if (!main) return;

                const addr = [];
                if (main.address1) addr.push(main.address1);
                if (main.address2) addr.push(main.address2);
                if (main.suburb) addr.push(main.suburb);
                if (main.city) addr.push(main.city);
                if (main.postalCode) addr.push(main.postalCode);

                const phoneValue =
                    main.cellphone ||
                    main.cellphoneNo ||
                    main.cell ||
                    main.mobile ||
                    main.phone ||
                    main.telephone ||
                    '';

                setPatientProfile(prev => {
                    const current = prev || {};
                    const existingAddr = Array.isArray(current.addressLines) ? current.addressLines : [];
                    const existingPhone = current.phone && String(current.phone).trim() ? current.phone : '';
                    return {
                        ...current,
                        addressLines: existingAddr.length ? existingAddr : addr,
                        phone: existingPhone || phoneValue,
                    };
                });
            } catch (e) {
            }
        })();
        return () => { alive = false; };
    }, [scriptData?.profileNo]);

    return patientProfile;
};
